export default {
  error: 'שגיאה',
  warning: 'אזהרה',
  'error.errorNum': 'שגיאה: {number}',
  'error.notFound': '{entity} לא נמצא',
  'error.page403': 'מצטערים, אין לך הרשאה לגשת לדף זה',
  'error.page404': 'מצטערים, הדף שביקרת בו אינו קיים',
  'error.page500': 'מצטערים, משהו השתבש',
  'error.pageWarning': 'קיימות בעיות בפעולה שלך',
  'error.noPermissions': 'אין הרשאות מתאימות',
  'error.userExist': 'המשתמש כבר קיים',
  'error.userAssigned': 'המשתמש כבר מוקצה לעסק',
  'error.noEmail': 'כתובת אימייל נדרשת',
  'error.validEmail': 'אנא הזן כתובת אימייל תקינה',
  'error.noConnection': 'אין חיבור לאינטרנט',
  'error.na': 'אין',
  'error.fileSize': 'גודל הקובץ חורג ממגבלת {size}MB',
  'error.uploadRestriction': 'ניתן להעלות רק קבצי {extensions}',
  'error.reCAPTCHA.loaded': 'reCAPTCHA לא נטען',
  'error.load.script': 'נכשל בטעינת הסקריפט',
};
